// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMilestoneHeader_root__BCtR4","text":"PlasmicMilestoneHeader_text__8itFo","closeButton":"PlasmicMilestoneHeader_closeButton__SyAn8"};